import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from 'ngx-markdown';

@Component({
  selector: 'lib-collaboration-delete-information-dialog',
  imports: [CommonModule, TranslateModule, MarkdownPipe],
  templateUrl: './collaboration-delete-information-dialog.component.html',
  styleUrl: './collaboration-delete-information-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollaborationDeleteInformationDialogComponent {
  private readonly dialogRef: DialogRef<void> = inject(DialogRef);

  public onConfirmDialog(): void {
    this.dialogRef.close();
  }
}
